import React from 'react'

const NoPage = () => {
  return (
    <div className='flex justify-center items-center flex-col min-h-full'>
      <p className='font-extrabold text-9xl mt-20'>
        <span className='text-primaryColor'>4</span>
        <span>0</span>
        <span className='text-primaryColor'>4</span>
      </p>
      <p className='font-semibold text-xl mt-4'>Page Not Found</p>
    </div>
  )
}

export default NoPage